import { render, staticRenderFns } from "./jingfanlist.vue?vue&type=template&id=f3e0c3a2&scoped=true&"
import script from "./jingfanlist.vue?vue&type=script&lang=js&"
export * from "./jingfanlist.vue?vue&type=script&lang=js&"
import style0 from "./jingfanlist.vue?vue&type=style&index=0&id=f3e0c3a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e0c3a2",
  null
  
)

export default component.exports